import { Box, Tooltip, styled } from '@mui/material'
import { useAppSelector } from '../../Common/_hooks/useAppSelector'
import { STORE_ICON_URLS } from '../StoreIconUrls'

const StoreIndicator = styled('span')(({ theme }) => ({
  width: 24,
  height: 24,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  overflow: 'hidden',
  padding: theme.spacing(0.5),
}))

const StoreIndicatorImg = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  display: 'block',
})

interface Props {
  storeSlug: string
}

export default function ProductDesignLinkedStoreIcon(props: Props) {
  const listStores = useAppSelector(state => state.get('appData').get('storeIntegrations'))
  const userStore = useAppSelector(state => state.get('userData').get('stores')
    .valueSeq()
    .find(store => store.get('slug') === props.storeSlug)
  )
  const integrationName = listStores.get(props.storeSlug)?.get('name') ?? props.storeSlug
  const storeName = (userStore?.get('store_name') ?? '').trim()
  const storeLabel = storeName !== '' ? integrationName + ' - ' + storeName : integrationName
  const tooltipTitle = storeName !== ''
    ? <>
      <Box component="strong" sx={{ fontWeight: '600' }}>{integrationName}</Box>
      <br />
      {storeName}
    </>
    : integrationName
  const storeIconUrl = STORE_ICON_URLS[props.storeSlug]

  return <Tooltip title={tooltipTitle}>
    <StoreIndicator aria-label={storeLabel}>
      {storeIconUrl ? <StoreIndicatorImg
        alt={storeLabel}
        src={storeIconUrl}
      /> : null}
    </StoreIndicator>
  </Tooltip>
}
